export default {
  register: {
    title: '新規登録', username: 'ユーザー名', phone: '電話番号', phoneCode: 'コード', email: 'メール', password: 'パスワード', captcha: '認証コード', smsCode: 'SMSコード', emailCode: 'メールコード',
    verificationCode: 'メール認証コード', invitationCode: '招待コード', loading: '読み込み中...', send: '送信', sendCode: 'コード送信', signUp: '新規登録', contactUs: 'お問い合わせ？', haveAccount: 'アカウントをお持ちですか？', signIn: 'ログイン', codeOptional: 'コード（任意）', privacyPolicy: '私は18歳以上であり、以下に同意します', privacyPolicyLink: 'プライバシーポリシー', and: 'および', termsConditions: '利用規約', vault: '金庫', receivePromos: 'メールプロモーションを受け取る', usernameRequired: 'ユーザー名を入力してください', usernameInvalid: 'ユーザー名は英数字とアンダースコアのみ使用できます', phoneRequired: '電話番号を入力してください', phoneInvalid: '電話番号の形式が無効です', emailRequired: 'メールアドレスを入力してください', emailInvalid: 'メールアドレスの形式が無効です', passwordRequired: 'パスワードを入力してください', passwordInvalid: 'パスワードが要件を満たしていません', captchaRequired: '認証コードを入力してください', smsCodeRequired: 'SMSコードを入力してください', emailCodeRequired: 'メールコードを入力してください', privacyPolicyRequired: 'プライバシーポリシーと利用規約に同意してください', passwordHintLow: '最低6桁', passwordHintMedium: '英字と数字を含む6文字以上', passwordHintHigh: '英字、数字、記号を含む6文字以上',
    // Format validation
    usernameFormat: '文字、数字、_のみ使用可能',
    emailFormat: 'メール形式が無効です',
    // Toast messages
    smsCodeSent: 'SMS認証コードを送信しました',
    emailCodeSent: 'メール認証コードを送信しました',
    smsCodeFailed: 'SMS認証コードの送信に失敗しました',
    emailCodeFailed: 'メール認証コードの送信に失敗しました',
    registerSuccess: '登録に成功しました',
    registerFailed: '登録に失敗しました',
    // Google sign in
    signInWithGoogle: 'Google+でサインイン',
    loginNow: 'ログイン',
    or: 'または',
    orSignUpWith: 'または次で登録',
    methodUsername: 'ユーザー名',
    methodPhone: '電話',
    methodEmail: 'メール',
  }
};
